import React from 'react';
import theme from 'theme/theme';
import RowActionButton from './RowActionButton';
import { DeleteIcon, EditIcon, LockIcon, FileDownloadIcon, EmailIcon, DashboardIcon, CopyIcon } from '../../Icon';
import NavLink from '../../NavLink';

export default RowActionButton;

const hasPermission = (entity, permission) => entity.permissions && entity.permissions[permission];

export const getEditColumn = onRowEdit => ({
  Header: <EditIcon color={theme.colors.medium} />,
  Cell: ({ original }) => {
    // eslint-disable-line

    if (
      (original.entityType === 'document' && !hasPermission(original, 'canWriteDocument')) ||
      (original.entityType === 'folder' && !hasPermission(original, 'canWrite'))
    ) {
      return <div />;
    }

    return (
      <RowActionButton original={original} handleClick={onRowEdit}>
        <EditIcon color={theme.colors.medium} />
      </RowActionButton>
    );
  },
  sortable: false,
  width: 50,
  showOnMobile: false,
});

export const getCloneColumn = onRowClone => ({
  Header: <CopyIcon color={theme.colors.medium} />,
  Cell: ({ original }) => {
    // eslint-disable-line

    if (original.entityType !== 'document' || !hasPermission(original, 'canWriteDocument')) {
      return <div />;
    }

    return (
      <RowActionButton original={original} handleClick={onRowClone}>
        <CopyIcon color={theme.colors.medium} />
      </RowActionButton>
    );
  },
  sortable: false,
  width: 50,
  showOnMobile: false,
});

export const getDeleteColumn = onRowDelete => ({
  Header: <DeleteIcon color={theme.colors.medium} />,
  Cell: ({ original }) => {
    // eslint-disable-line
    if (
      (original.entityType === 'document' && !hasPermission(original, 'canDeleteDocument')) ||
      (original.entityType === 'folder' && !hasPermission(original, 'canDelete'))
    ) {
      return <div />;
    }

    return (
      <RowActionButton original={original} handleClick={onRowDelete}>
        <DeleteIcon color={theme.colors.medium} />
      </RowActionButton>
    );
  },
  sortable: false,
  width: 50,
  showOnMobile: false,
});

export const getPermissionColumn = () => ({
  Header: <LockIcon color={theme.colors.medium} />,
  Cell: (
    { original }, // eslint-disable-line
  ) => (
    <RowActionButton original={original}>
      <NavLink to={`/admin/permissions/${original.id}`}>
        <LockIcon color={theme.colors.medium} />
      </NavLink>
    </RowActionButton>
  ),
  sortable: false,
  width: 50,
});

export const getDownloadColumn = onClick => ({
  Header: <FileDownloadIcon color={theme.colors.medium} />,
  Cell: (
    { original }, // eslint-disable-line
  ) => (
    <RowActionButton original={original} handleClick={onClick}>
      <FileDownloadIcon color={theme.colors.medium} />
    </RowActionButton>
  ),
  sortable: false,
  width: 50,
});

export const getShareColumn = onClick => ({
  Header: <EmailIcon color={theme.colors.medium} />,
  Cell: ({ original }) => {
    // eslint-disable-line
    if (!hasPermission(original, 'canShare')) {
      return <div />;
    }
    return (
      <RowActionButton original={original} handleClick={onClick}>
        <EmailIcon color={theme.colors.medium} />
      </RowActionButton>
    );
  },
  sortable: false,
  width: 50,
});

export const getDefaultFavoritesColumn = onClick => ({
  Header: <DashboardIcon color={theme.colors.medium} />,
  Cell: ({ original }) => (
    <RowActionButton original={original} handleClick={onClick}>
      <DashboardIcon color={theme.colors.medium} />
    </RowActionButton>
  ),
  sortable: false,
  width: 50,
});
